import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const InvestmentRegistration = lazy(() => import('../../container/investment/investmentRegistration'));
const InvestmentList = lazy(() => import('../../container/investment/investmentList'));
const InvestmentUpdate = lazy(() => import('../../container/investment/investmentUpdate'));
const InvestmentDetails = lazy(() => import('../../container/investment/InvestmentDetail/investmentDetails'));

export default function InvestorRoute() {
  return (
    <Routes>
      <Route path="registration" element={<InvestmentRegistration />} />
      <Route path="list" element={<InvestmentList />} />
      <Route path="detail/:id" element={<InvestmentDetails />} />
      <Route path="update/:id" element={<InvestmentUpdate />} />
    </Routes>
  );
}
